export const applicationTypes = {
  applicationTypeFastApply: "application_type_fast_apply",
  fastApplyAssignmentsRequested: "fast_apply_assignments_requested",
  fastApplyAssignmentsCompeted: "fast_apply_assignments_completed",
  applicationTypeInternal: "application_type_internal",
  applicationTypeExternal: "application_type_external",
  fastApplyApplied: "fast_apply_applied",
  applicationTypeAts: "application_type_ats"
};
